// @ts-nocheck
import React, { useState } from 'react';
import { Typography, Button, Stack, Snackbar, Alert } from '@mui/material';
import EditUserQuota from '../../components/EditUserQuota';
import useUpdateQuota from '../../hooks/KnowledgeAI/useUpdateQuota';

// ----------------------------------------------------------------------

export default function GeneralConfiguration() {
  const [editQuotaOpen, setEditQuotaOpen] = useState(false);
  const [quotaSuccess, setQuotaSuccess] = useState(false);
  const { updateQuota, loading: quotaLoading } = useUpdateQuota();

  const handleSaveSuccess = () => {
    setEditQuotaOpen(false);
    setQuotaSuccess(true);
  };

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
        <div>
          <Typography variant="h6">User Token Quota</Typography>
          <Typography variant="body2" color="text.secondary">
            Set the global monthly token quota for all users.
          </Typography>
        </div>
        <Button variant="contained" className="primary-btn" onClick={() => setEditQuotaOpen(true)}>
          Edit Quota
        </Button>
      </Stack>

      <EditUserQuota
        open={editQuotaOpen}
        onClose={() => setEditQuotaOpen(false)}
        user={{}}
        onSaveSuccess={handleSaveSuccess}
        updateQuota={updateQuota}
        loading={quotaLoading}
        isGlobal={true}
      />

      <Snackbar
        open={quotaSuccess}
        autoHideDuration={4000}
        onClose={() => setQuotaSuccess(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setQuotaSuccess(false)} severity="success">
          Token quota updated successfully.
        </Alert>
      </Snackbar>
    </>
  );
}
